// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader--preloader--rO6n+","preloader__logo":"Preloader--preloader__logo--DLrS6"};